import { invariant } from '@vp/digital-invariant-lib';
import React, { useState, useEffect } from 'react';
import { none, some, isNone, isSome } from 'fp-ts/lib/Option';
import { Helmet } from 'react-helmet';
import { useLocale } from '@vp/digital-locale-lib';
import { getClientEnvironment, Environment } from '@vp/digital-environment-lib';
import { getLogger, getLibLoggingMetadata, Dispenser } from '@vp/digital-logging-lib';
import { BasicPreloader, Typography } from '@vp/swan';
import { SERVICE_LENGTH_ATTRIBUTE_NAME, getServiceLength } from '@vp/digital-product-lib';
import { makeUseAxios } from 'axios-hooks';
import { RetryPolicy, HttpClientDispenser } from '@vp/digital-http-client-lib';
import util from 'util';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var cdn = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.latestPricingContextModuleUrl = void 0;
var latestPricingContextModuleUrl = "https://pricing-context-module.products.vpsvc.com/static/v3/pricing-context-module.min.js";
exports.latestPricingContextModuleUrl = latestPricingContextModuleUrl;
var _default = {
  latestPricingContextModuleUrl: latestPricingContextModuleUrl
};
exports["default"] = _default;
});

unwrapExports(cdn);
var cdn_1 = cdn.latestPricingContextModuleUrl;

var helpers = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getPcxtV3 = exports.executeAfterPricingContextEvent = exports.initializePricingContext = exports.QUERY_PARAMETERS = exports.EVENTS = exports.COOKIE_DATA = void 0;
// If updated, please REMEMBER to update the mirroring constants in pricing-context-module.js
var COOKIE_NAME = 'PCXT';
var COOKIE_REGEX = new RegExp("(^| )".concat(COOKIE_NAME, "=([^;]+)"));
var SCRIPT_LOADED_EVENT = 'PCXT-V3-ScriptLoaded';
var INITIALIZED_EVENT = 'PCXT-V3-ModuleInitialized';
var CONTEXT_CHANGE_EVENT = 'PCXT-V3-ContextChanged';
var COUPON_CHANGE_EVENT = 'PCXT-V3-CouponCodeChanged';
var VAT_INCLUSIVITY_CHANGE_EVENT = 'PCXT-V3-VatInclusivityChanged';
var DATE_TIME_CHANGE_EVENT = 'PCXT-V3-EffectiveDateTimeChanged';
var VAT_INCLUSIVITY_QUERY_PARAMETER = 'PCXTVATINCLUSIVE';
var DATE_TIME_QUERY_PARAMETER = 'PCXTEFFECTIVEDATETIME';

var windowAndDocumentExist = function windowAndDocumentExist() {
  return typeof window !== 'undefined' && window.document;
};

var COOKIE_DATA = {
  COOKIE_NAME: COOKIE_NAME,
  COOKIE_REGEX: COOKIE_REGEX
};
exports.COOKIE_DATA = COOKIE_DATA;
var EVENTS = {
  SCRIPT_LOADED_EVENT: SCRIPT_LOADED_EVENT,
  INITIALIZED_EVENT: INITIALIZED_EVENT,
  CONTEXT_CHANGE_EVENT: CONTEXT_CHANGE_EVENT,
  COUPON_CHANGE_EVENT: COUPON_CHANGE_EVENT,
  VAT_INCLUSIVITY_CHANGE_EVENT: VAT_INCLUSIVITY_CHANGE_EVENT,
  DATE_TIME_CHANGE_EVENT: DATE_TIME_CHANGE_EVENT
};
exports.EVENTS = EVENTS;
var QUERY_PARAMETERS = {
  VAT_INCLUSIVITY_QUERY_PARAMETER: VAT_INCLUSIVITY_QUERY_PARAMETER,
  DATE_TIME_QUERY_PARAMETER: DATE_TIME_QUERY_PARAMETER
};
exports.QUERY_PARAMETERS = QUERY_PARAMETERS;

var ignore = function ignore() {};

var registerCustomInitCallback = function registerCustomInitCallback(configuration, callback) {
  if (typeof callback !== 'function') {
    return;
  }

  if (window.document.pcxtV3 && window.document.pcxtV3.isInitialized(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)) {
    callback(window.document.pcxtV3.getPricingContext());
  } else {
    window.document.addEventListener(INITIALIZED_EVENT, function onInit(e) {
      window.document.removeEventListener(INITIALIZED_EVENT, onInit, false);
      callback(e.detail);
    });
  }
};

var callPCMInit = function callPCMInit(configuration) {
  window.document.pcxtV3.init(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)["catch"](ignore);
};

var initializePricingContext = function initializePricingContext(configuration, callback) {
  if (!windowAndDocumentExist()) {
    return;
  }

  registerCustomInitCallback(configuration, callback);

  if (window.document.pcxtV3) {
    callPCMInit(configuration);
  } else {
    window.document.addEventListener(SCRIPT_LOADED_EVENT, function callback() {
      window.document.removeEventListener(SCRIPT_LOADED_EVENT, callback, false);
      callPCMInit(configuration);
    });
  }
};

exports.initializePricingContext = initializePricingContext;

var executeAfterPricingContextEvent = function executeAfterPricingContextEvent(event, callback, continueListening) {
  if (typeof callback !== 'function') {
    return;
  }

  if (Object.values(EVENTS).indexOf(event) === -1) {
    console.warn("Event '".concat(event, "' is NOT a valid pricing context event."));
    return;
  }

  if (!windowAndDocumentExist()) {
    return;
  }

  window.document.addEventListener(event, function onEvent(e) {
    if (!continueListening) {
      window.document.removeEventListener(event, onEvent, false);
    }

    callback(e.detail);
  });
};

exports.executeAfterPricingContextEvent = executeAfterPricingContextEvent;

var getPcxtV3 = function getPcxtV3() {
  if (!windowAndDocumentExist()) {
    return undefined;
  }

  return window.document.pcxtV3;
};

exports.getPcxtV3 = getPcxtV3;
var _default = {
  COOKIE_DATA: COOKIE_DATA,
  EVENTS: EVENTS,
  QUERY_PARAMETERS: QUERY_PARAMETERS,
  initializePricingContext: initializePricingContext,
  executeAfterPricingContextEvent: executeAfterPricingContextEvent,
  getPcxtV3: getPcxtV3
};
exports["default"] = _default;
});

unwrapExports(helpers);
helpers.getPcxtV3;
var helpers_2 = helpers.executeAfterPricingContextEvent;
var helpers_3 = helpers.initializePricingContext;
helpers.QUERY_PARAMETERS;
var helpers_5 = helpers.EVENTS;
helpers.COOKIE_DATA;

var vatCountries = [
    { country: 'Austria', countryCode: 'AT' },
    { country: 'Belgium', countryCode: 'BE' },
    { country: 'Bulgaria', countryCode: 'BG' },
    { country: 'Switzerland', countryCode: 'CH' },
    { country: 'Cyprus', countryCode: 'CY' },
    { country: 'Czech Republic', countryCode: 'CZ' },
    { country: 'Germany', countryCode: 'DE' },
    { country: 'Denmark', countryCode: 'DK' },
    { country: 'Estonia', countryCode: 'EE' },
    { country: 'Spain', countryCode: 'ES' },
    { country: 'Finland', countryCode: 'FI' },
    { country: 'France', countryCode: 'FR' },
    { country: 'Greece', countryCode: 'GR' },
    { country: 'Croatia (Hrvatska)', countryCode: 'HR' },
    { country: 'Hungary', countryCode: 'HU' },
    { country: 'Ireland', countryCode: 'IE' },
    { country: 'Italy', countryCode: 'IT' },
    { country: 'Japan', countryCode: 'JP' },
    { country: 'Liechtenstein', countryCode: 'LI' },
    { country: 'Lithuania', countryCode: 'LT' },
    { country: 'Luxembourg', countryCode: 'LU' },
    { country: 'Latvia', countryCode: 'LV' },
    { country: 'Monaco', countryCode: 'MC' },
    { country: 'Malta', countryCode: 'MT' },
    { country: 'Netherlands', countryCode: 'NL' },
    { country: 'Norway', countryCode: 'NO' },
    { country: 'New Zealand', countryCode: 'NZ' },
    { country: 'Poland', countryCode: 'PL' },
    { country: 'Portugal', countryCode: 'PT' },
    { country: 'Romania', countryCode: 'RO' },
    { country: 'Sweden', countryCode: 'SE' },
    { country: 'Slovenia', countryCode: 'SI' },
    { country: 'Slovakia', countryCode: 'SK' },
    { country: 'United Kingdom', countryCode: 'GB' },
    { country: 'United Kingdom', countryCode: 'UK' },
    { country: 'South Africa', countryCode: 'ZA' },
];

function getIsVatSupported(currentCountryCode) {
    return vatCountries.some(function (_a) {
        var countryCode = _a.countryCode;
        return countryCode.toUpperCase() === currentCountryCode;
    });
}

var name = "@vp/digital-pricing-lib";
var version = "0.11.0";

var getPricingLogger = function (settings) {
    var meta = getLibLoggingMetadata(name, version, settings);
    return getLogger(meta);
};

var DEFAULT_MERCHANT_ID = 'VISTAPRINT';
var windowAndDocumentExist = function () {
    return typeof window !== 'undefined' && window.document;
};
var getPricingContextModuleV3 = function () {
    return windowAndDocumentExist() && window.document.pcxtV3;
};
var PricingContextContext = React.createContext(undefined);
function PricingContextProvider(_a) {
    var _b = _a.merchantId, merchantId = _b === void 0 ? DEFAULT_MERCHANT_ID : _b, children = _a.children;
    var countryCode = useLocale().countryCode;
    var _c = useState(none), pricingContext = _c[0], setPricingContext = _c[1];
    var isNonProdEnv = getClientEnvironment() !== Environment.Prod;
    useEffect(function () {
        var pricingContextConfig = {
            merchantId: merchantId,
            market: countryCode,
            isDevelopmentMode: isNonProdEnv,
        };
        var logger = getPricingLogger();
        var updatePricingContext = function () {
            var pricingContextModule = getPricingContextModuleV3();
            invariant(pricingContextModule, 'pricing Context Module does not exist on document');
            var newPricingContext = {
                contextAsQueryString: pricingContextModule.getContextAsQueryString(),
                encodedContextString: pricingContextModule.getEncodedContextString(),
                isVatInclusive: pricingContextModule.isVatInclusive(),
                isVatSupported: getIsVatSupported(countryCode),
            };
            logger.debug('Updating Pricing Context', newPricingContext);
            setPricingContext(some(newPricingContext));
        };
        logger.debug('Initializing Pricing Context Module', pricingContextConfig);
        helpers_3(pricingContextConfig, updatePricingContext);
        helpers_2(helpers_5.CONTEXT_CHANGE_EVENT, updatePricingContext, true);
    }, [countryCode, isNonProdEnv, merchantId]);
    return (React.createElement(PricingContextContext.Provider, { value: pricingContext },
        React.createElement(Helmet, null,
            React.createElement("script", { src: cdn_1, type: "text/javascript" })),
        children));
}
function usePricingContext() {
    var context = React.useContext(PricingContextContext);
    invariant(context, 'usePricingContext must be used within a PricingContextProvider');
    return context;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var contentfulMapper = function (billingPeriodData) {
    return billingPeriodData.map(function (billingPeriod) { return ({
        serviceLengthAttributeKey: billingPeriod.node.billingPeriodAttribute.mcpAttribute.value,
        billingPeriodDisclaimerText: billingPeriod.node.billingPeriodDisclaimerText,
        billingPeriodText: billingPeriod.node.periodText,
        perPeriodText: billingPeriod.node.perPeriodText,
        monthsInPeriod: billingPeriod.node.monthsInPeriod,
        promotionalPricingDisclaimerSymbol: billingPeriod.node.promotionalPricingDisclaimerSymbol,
        promotionalPricingDisclaimerText: billingPeriod.node.promotionalPricingDisclaimerText,
        vatExclusiveText: billingPeriod.node.vatExclusiveText,
        vatInclusiveText: billingPeriod.node.vatInclusiveText,
        billingPeriodAttribute: billingPeriod.node.billingPeriodAttribute.mcpAttribute,
    }); });
};

var BillingPeriodKeys = {
    Tower: 'tower',
    WixBillingCycle: 'wixBillingCycle',
    WixPlansGrid: 'wixPlansGrid',
    WixDomainsRegistrationPeriod: 'wixDomainsRegistrationPeriod',
};
function getLocaleBillingPeriodsContentful(graphql, locale, key) {
    return __awaiter(this, void 0, void 0, function () {
        var query, params, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = "\nquery getLocaleBillingPeriods($locale:String!, $key:String) {\n  allContentfulBillingPeriod(filter: {node_locale: {eq: $locale}, key: {eq: $key}}) {\n    edges {\n      node {\n        node_locale\n        key\n        contentfulName\n        billingPeriodDisclaimerText\n        billingPeriodAttribute {\n          keyDisplayName\n          valueDisplayName\n          contentfulName\n          mcpAttribute {\n            name\n            value\n          }\n        }\n        monthsInPeriod\n        perPeriodText\n        periodText\n        promotionalPricingDisclaimerSymbol\n        promotionalPricingDisclaimerText\n        vatExclusiveText\n        vatInclusiveText\n      }\n    }\n  }\n}";
                    params = { locale: locale, key: key };
                    return [4, graphql(query, params)];
                case 1:
                    result = _a.sent();
                    return [2, result];
            }
        });
    });
}
function getLocaleBillingPeriods(graphql, locale, key) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getLocaleBillingPeriodsContentful(graphql, locale, key)];
                case 1:
                    result = _a.sent();
                    if (result.errors) {
                        return [2, Promise.reject(result.errors)];
                    }
                    return [2, contentfulMapper(result.data.allContentfulBillingPeriod.edges)];
            }
        });
    });
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var PricingContentContext = React.createContext(undefined);
var NO_BILLING_PERIOD_DISCLAIMER_TEXT = '';
function getPeriod(periods, periodKey) {
    invariant(periodKey, 'The period key is required');
    var period = periods.find(function (period) {
        return period.serviceLengthAttributeKey === periodKey;
    });
    invariant(period, "No period content for key: ".concat(periodKey));
    return period;
}
function getBillingPeriodContent(periods, pricePeriodKey, displayPeriodKey) {
    invariant(periods, 'The periods array is required');
    var pricePeriod = getPeriod(periods, pricePeriodKey);
    var displayPeriod = getPeriod(periods, displayPeriodKey);
    var billingPeriodDisclaimerText = displayPeriodKey === pricePeriodKey
        ? NO_BILLING_PERIOD_DISCLAIMER_TEXT
        : pricePeriod.billingPeriodDisclaimerText;
    return {
        serviceLengthAttributeKey: pricePeriod.serviceLengthAttributeKey,
        vatInclusiveText: pricePeriod.vatInclusiveText,
        vatExclusiveText: pricePeriod.vatExclusiveText,
        billingPeriodText: pricePeriod.billingPeriodText,
        perPeriodText: displayPeriod.perPeriodText,
        billingPeriodDisclaimerText: billingPeriodDisclaimerText,
        promotionalPricingDisclaimerText: pricePeriod.promotionalPricingDisclaimerText,
        promotionalPricingDisclaimerSymbol: pricePeriod.promotionalPricingDisclaimerSymbol,
        monthsInPeriod: pricePeriod.monthsInPeriod,
        billingPeriodAttribute: pricePeriod.billingPeriodAttribute,
    };
}
function getPromotionalDisclaimerContent(periods, periodKey) {
    invariant(periods, 'The periods array is required');
    var period = getPeriod(periods, periodKey);
    return {
        promotionalPricingDisclaimerText: period.promotionalPricingDisclaimerText,
        promotionalPricingDisclaimerSymbol: period.promotionalPricingDisclaimerSymbol,
    };
}
function PricingContentProvider(_a) {
    var pricingContent = _a.pricingContent, children = _a.children;
    invariant(pricingContent, 'PricingContentProvider requires pricingContent');
    return (React.createElement(PricingContentContext.Provider, { value: pricingContent }, children));
}
function useBillingPeriodContent(billingPeriodKey, displayPeriodKey) {
    var context = React.useContext(PricingContentContext);
    invariant(context, 'useBillingPeriodContent must be used within a PricingContentProvider');
    return getBillingPeriodContent(context, billingPeriodKey, displayPeriodKey || billingPeriodKey);
}
function usePromotionalDisclaimerContent(billingPeriodKey) {
    var context = React.useContext(PricingContentContext);
    invariant(context, 'usePromotionalDisclaimerContent must be used within a PricingContentProvider');
    return getPromotionalDisclaimerContent(context, billingPeriodKey);
}

var isWholeNumber = function (num) { return num % 1 === 0; };
var formatPrice = function (culture, currency, minimumFractionDigits, price) {
    var numDigits = isWholeNumber(price) ? 0 : minimumFractionDigits;
    var formattedPrice = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: numDigits,
        minimumFractionDigits: numDigits,
    }).format(price);
    return formattedPrice;
};
var getPricePerDisplayPeriod = function (displayPeriod, period, price) {
    var factor = displayPeriod.monthsInPeriod / period.monthsInPeriod;
    return price * factor;
};
var getVatText = function (pricePeriodContent, pricingContext) {
    if (!pricingContext.isVatSupported) {
        return '';
    }
    return pricingContext.isVatInclusive
        ? pricePeriodContent.vatInclusiveText
        : pricePeriodContent.vatExclusiveText;
};
var useDisplayPriceContent = function (price, displayPeriodKey, productIdentifier) {
    var displayPeriodContent = useBillingPeriodContent(displayPeriodKey);
    var pricePeriodContent = useBillingPeriodContent((price === null || price === void 0 ? void 0 : price.serviceLengthAttributeKey) ||
        (productIdentifier === null || productIdentifier === void 0 ? void 0 : productIdentifier.productAttributes.find(function (attr) { return attr.key === SERVICE_LENGTH_ATTRIBUTE_NAME; }).value), displayPeriodContent.serviceLengthAttributeKey);
    var pricingContextOption = usePricingContext();
    if (!price || isNone(pricingContextOption)) {
        return {};
    }
    var pricingContext = pricingContextOption.value;
    var rawPrice = pricingContext.isVatInclusive
        ? price.taxed
        : price.untaxed;
    var displayListPrice = getPricePerDisplayPeriod(displayPeriodContent, pricePeriodContent, rawPrice.listPrice);
    var formattedListPrice = formatPrice(price.culture, price.currency, price.minimumFractionDigits, displayListPrice);
    var displayDiscountPrice = getPricePerDisplayPeriod(displayPeriodContent, pricePeriodContent, rawPrice.discountPrice);
    var formattedDiscountPrice = formatPrice(price.culture, price.currency, price.minimumFractionDigits, displayDiscountPrice);
    var vatText = getVatText(pricePeriodContent, pricingContext);
    var showDiscountPrice = rawPrice.listPrice > rawPrice.discountPrice;
    return {
        displayPeriodContent: displayPeriodContent,
        pricePeriodContent: pricePeriodContent,
        displayListPrice: displayListPrice,
        formattedListPrice: formattedListPrice,
        displayDiscountPrice: displayDiscountPrice,
        formattedDiscountPrice: formattedDiscountPrice,
        vatText: vatText,
        showDiscountPrice: showDiscountPrice,
    };
};

var Pricing = function (_a) {
    var containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, disclaimerTag = _a.disclaimerTag, disclaimerTextSize = _a.disclaimerTextSize, disclaimerTextWeight = _a.disclaimerTextWeight, className = _a.className, price = _a.price, displayPeriodKey = _a.displayPeriodKey;
    if (!price) {
        return (React.createElement(BasicPreloader, { className: className, visuallyHiddenLabel: "Loading", centered: true, inline: true }));
    }
    return (React.createElement(PricingInternal, { containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, disclaimerTag: disclaimerTag, disclaimerTextSize: disclaimerTextSize, disclaimerTextWeight: disclaimerTextWeight, className: className, price: price, displayPeriodKey: displayPeriodKey }));
};
var PricingInternal = function (_a) {
    var _b = _a.containerTag, ContainerTag = _b === void 0 ? 'span' : _b, _c = _a.priceTag, PriceTag = _c === void 0 ? 'span' : _c, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, _d = _a.disclaimerTag, disclaimerTag = _d === void 0 ? 'span' : _d, disclaimerTextSize = _a.disclaimerTextSize, disclaimerTextWeight = _a.disclaimerTextWeight, className = _a.className, price = _a.price, displayPeriodKey = _a.displayPeriodKey;
    var _e = useDisplayPriceContent(price, displayPeriodKey), pricePeriodContent = _e.pricePeriodContent, formattedListPrice = _e.formattedListPrice, formattedDiscountPrice = _e.formattedDiscountPrice, vatText = _e.vatText, showDiscountPrice = _e.showDiscountPrice;
    return (React.createElement(ContainerTag, { className: className },
        React.createElement(PriceTag, { className: classnames('pricing__list-price__container', {
                'pricing__comparative-pricing': showDiscountPrice,
            }) },
            formattedListPrice && (React.createElement(Typography, { fontSize: priceTextSize, component: "span", weight: priceTextWeight, className: "pricing__list-price" }, formattedListPrice)),
            (pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText) && (React.createElement(Typography, { fontSize: priceTextSize, component: "span", weight: priceTextWeight, className: "pricing__price-period" }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText)),
            showDiscountPrice && (React.createElement(Typography, { component: "span", fontSize: priceTextSize, weight: priceTextWeight }, "\u00A0")),
            showDiscountPrice && (React.createElement("span", { className: classnames('pricing__discount-price', {
                    'pricing__discount-price__container': !!discountTextSize,
                    'pricing__discount-price__aligned': discountAligned,
                }) },
                formattedDiscountPrice &&
                    (pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.promotionalPricingDisclaimerSymbol) && (React.createElement(Typography, { component: "span", weight: discountTextWeight, fontSize: discountTextSize },
                    formattedDiscountPrice, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 :
                    pricePeriodContent.promotionalPricingDisclaimerSymbol)),
                (pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText) && (React.createElement(Typography, { fontSize: discountTextSize, component: "span", weight: discountTextWeight }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText))))),
        (vatText || (pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.billingPeriodDisclaimerText)) && (React.createElement(Typography, { fontSize: disclaimerTextSize, component: disclaimerTag, weight: disclaimerTextWeight, m: 0, p: 0 },
            ' ',
            vatText,
            (pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.billingPeriodDisclaimerText) && (React.createElement("span", { className: "pricing__description" },
                ' ', pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 :
                pricePeriodContent.billingPeriodDisclaimerText))))));
};

var defaultConfig$1 = {
    pricingApi: {
        baseUrl: 'https://vistaprint-org-product-catalog-product-pricing-service.products.vpsvc.com',
        operations: {
            getPrice: {
                timeoutMS: 3 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
                parameters: {
                    requestor: 'Digital Merchandising',
                    merchantId: 'Vistaprint',
                },
            },
        },
    },
};

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat$1 = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$1 = functionBind.call(Function.call, String.prototype.replace);
var $strSlice = functionBind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
var $max = getIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(functionBind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});
callBind.apply;

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var util_inspect = util.inspect;

var require$$0 = util_inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = require$$0.custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$3(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$3(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$3(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$3(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$3(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$3(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$3(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var inspect = objectInspect;

var $TypeError = getIntrinsic('%TypeError%');
var $WeakMap = getIntrinsic('%WeakMap%', true);
var $Map = getIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$2(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$2(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$2(target) && !isArray$2(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$2(target) && isArray$2(source)) {
        source.forEach(function (item, i) {
            if (has$2.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$2.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$2(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

var has$1 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$1 = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults$1 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel$1
) {
    var obj = object;

    var tmpSc = sideChannel$1;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$1(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$1(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel$1.set(object, step);
        var valueSideChannel = sideChannel();
        valueSideChannel.set(sentinel, sideChannel$1);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$1;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$1.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$1.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults$1.filter;
    if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$1(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel$1 = sideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel$1
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

var parse = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify_1
};

function getPricingApiRequestParameters(pricingContext, productIdentifier, quantity, opConfig) {
    var params = productIdentifier.productAttributes.reduce(function (p, attr) {
        var _a;
        return (__assign(__assign({}, p), (_a = {}, _a["Selections[".concat(attr.key, "]")] = attr.value, _a)));
    }, __assign(__assign({}, lib.parse(pricingContext.contextAsQueryString)), { requestor: opConfig.parameters.requestor, quantities: quantity.toString(), productKey: productIdentifier.productKey, productVersion: productIdentifier.productVersion }));
    return params;
}
var transformPricingApiResponseData = function (locale, productIdentifier, quantity, response) {
    var _a;
    var estimatedPrice = (_a = response === null || response === void 0 ? void 0 : response.estimatedPrices) === null || _a === void 0 ? void 0 : _a[quantity];
    var price = {
        quantity: quantity,
        taxed: {
            listPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalListPrice.taxed,
            discountPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalDiscountedPrice.taxed,
        },
        untaxed: {
            listPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalListPrice.untaxed,
            discountPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalDiscountedPrice.untaxed,
        },
        currency: response.currency,
        minimumFractionDigits: response.fractionDigits,
        culture: locale,
        serviceLengthAttributeKey: getServiceLength(productIdentifier),
    };
    return price;
};

var apiConfig$1 = defaultConfig$1.pricingApi;
var opConfig$1 = apiConfig$1.operations.getPrice;
var pricingClientDispenser = new HttpClientDispenser(apiConfig$1, opConfig$1);
var pricingHookDispenser = new Dispenser(function () {
    return makeUseAxios({
        axios: pricingClientDispenser.getInstance(),
        defaultOptions: { manual: true },
    });
});
function usePrice(productIdentifier, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var pricingContext = usePricingContext();
    var locale = useLocale().identifier;
    var _a = pricingHookDispenser.getInstance()({}), responseValues = _a[0], fetchPrice = _a[1];
    useEffect(function () {
        var logger = getPricingLogger();
        if (isSome(pricingContext)) {
            var params = getPricingApiRequestParameters(pricingContext.value, productIdentifier, quantity, opConfig$1);
            var transformResponse = function (data) {
                if (!data)
                    return;
                return transformPricingApiResponseData(locale, productIdentifier, quantity, data);
            };
            var newTransformers = []
                .concat(pricingClientDispenser.getInstance().defaults.transformResponse)
                .concat(transformResponse);
            var axiosConfig = {
                url: 'https://website-pricing-service-cdn.prices.cimpress.io/v4/prices/estimated',
                method: 'get',
                params: params,
                transformResponse: newTransformers,
                paramsSerializer: function (params) {
                    return Object.entries(params)
                        .reduce(function (query, param) {
                        return Array.isArray(param[1])
                            ? "".concat(query).concat(param[1].reduce(function (query, arrayParam) {
                                return "".concat(query).concat(param[0], "=").concat(arrayParam, "&");
                            }, ''))
                            : "".concat(query).concat(param[0], "=").concat(param[1], "&");
                    }, '')
                        .split(' ')
                        .join('+');
                },
            };
            fetchPrice(axiosConfig)
                .then(function () { })
                .catch(function (error) {
                logger.error('Error while receiving prices', error);
            });
        }
    }, [fetchPrice, locale, pricingContext, productIdentifier, quantity]);
    return responseValues;
}

var PricingContainer = function (_a) {
    var containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, disclaimerTag = _a.disclaimerTag, disclaimerTextSize = _a.disclaimerTextSize, disclaimerTextWeight = _a.disclaimerTextWeight, displayPeriodKey = _a.displayPeriodKey, productIdentifier = _a.productIdentifier, quantity = _a.quantity, priceData = _a.priceData, _b = _a.priceDataProvided, priceDataProvided = _b === void 0 ? false : _b, className = _a.className;
    var price = priceDataProvided
        ? priceData
        :
            usePrice(productIdentifier, quantity).data;
    return (React.createElement(Pricing, { containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, disclaimerTag: disclaimerTag, disclaimerTextSize: disclaimerTextSize, disclaimerTextWeight: disclaimerTextWeight, price: price, displayPeriodKey: displayPeriodKey, className: className }));
};

var PromotionalDisclaimer = function (_a) {
    var billingPeriodKey = _a.billingPeriodKey, _b = _a.tag, Tag = _b === void 0 ? 'p' : _b, className = _a.className;
    var promotionalPricingContent = usePromotionalDisclaimerContent(billingPeriodKey);
    return (React.createElement(React.Fragment, null, promotionalPricingContent.promotionalPricingDisclaimerText && (React.createElement(Tag, { className: classnames('pricing__promotional-disclaimer', className) },
        promotionalPricingContent.promotionalPricingDisclaimerSymbol,
        promotionalPricingContent.promotionalPricingDisclaimerText))));
};

var defaultConfig = {
    wranglerApi: {
        baseUrl: 'https://wrangler.prod.merch.vpsvc.com',
        operations: {
            getWranglerPrice: {
                timeoutMS: 3 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
                parameters: {
                    requestor: 'Digital Merchandising',
                    merchantId: 'Vistaprint',
                },
            },
        },
    },
};

function getWranglerApiRequestParameters(pricingContext, connection, merchandisingExperience, responseComponents) {
    var params = {
        pricingContextString: pricingContext.contextAsQueryString,
        'selectedAttributes[Connection]': connection,
        includeVat: pricingContext.isVatInclusive,
        merchandisingExperience: merchandisingExperience,
        responseComponents: responseComponents,
    };
    return params;
}
var transformWranglerApiResponseData = function (isVatInclusive, countryCode, response) {
    var _a, _b, _c;
    var wranglerPriceData = (_a = response.standardConfigurator) === null || _a === void 0 ? void 0 : _a.price;
    var wranglerMetadata = response.standardConfigurator;
    var priceInfo = {
        quantities: ((_c = (_b = wranglerMetadata === null || wranglerMetadata === void 0 ? void 0 : wranglerMetadata.quantities) === null || _b === void 0 ? void 0 : _b.quantities) !== null && _c !== void 0 ? _c : []).map(function (q) { return ({
            quantity: parseInt(q.quantity),
            culture: countryCode,
            currency: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.currency,
            listPrice: q.totalListPrice,
            discountPrice: q.totalDiscountedPrice,
            unitListPrice: q.unitListPrice,
            unitDiscountPrice: q.unitDiscountedPrice,
            badges: q.badges,
            vatInc: isVatInclusive,
            minimumFractionDigits: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.fractionDigits,
            hideVatMessage: false,
        }); }),
        culture: countryCode,
        currency: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.currency,
        vatInc: isVatInclusive !== null && isVatInclusive !== void 0 ? isVatInclusive : false,
        minimumFractionDigits: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.fractionDigits,
        hideVatMessage: false,
    };
    return { priceInfo: priceInfo, wranglerMetadata: wranglerMetadata };
};

var VISTAPRINT_TENANT = 'vistaprint';
var MERCHANDISING_EXPERIENCE = 'Product Page';
var RESPONSE_COMPONENT = 'standardConfigurator';
var apiConfig = defaultConfig.wranglerApi;
var opConfig = apiConfig.operations.getWranglerPrice;
var wranglerClientDispenser = new HttpClientDispenser(apiConfig, opConfig);
var wranglerHookDispenser = new Dispenser(function () {
    return makeUseAxios({
        axios: wranglerClientDispenser.getInstance(),
        defaultOptions: { manual: true },
    });
});
function useWranglerPrice(productKey, productVersion, connection) {
    var pricingContext = usePricingContext();
    var countryCode = useLocale().identifier;
    var _a = wranglerHookDispenser.getInstance()({}), responseValues = _a[0], fetchPrice = _a[1];
    useEffect(function () {
        if (isSome(pricingContext)) {
            var params = getWranglerApiRequestParameters(pricingContext.value, connection, MERCHANDISING_EXPERIENCE, RESPONSE_COMPONENT);
            var transformResponse = function (data) {
                if (!data)
                    return;
                return transformWranglerApiResponseData(pricingContext.value.isVatInclusive, countryCode, data);
            };
            var newTransformers = []
                .concat(wranglerClientDispenser.getInstance().defaults.transformResponse)
                .concat(transformResponse);
            var axiosConfig = {
                url: "/api/v1/".concat(VISTAPRINT_TENANT, "/").concat(countryCode, "/configuratorData/").concat(productKey, "/").concat(productVersion),
                method: 'get',
                params: params,
                transformResponse: newTransformers,
            };
            fetchPrice(axiosConfig);
        }
    }, [
        connection,
        countryCode,
        fetchPrice,
        pricingContext,
        productKey,
        productVersion,
    ]);
    return responseValues;
}

export { BillingPeriodKeys, Pricing, PricingContainer, PricingContentProvider, PricingContextProvider, PromotionalDisclaimer, formatPrice, getLocaleBillingPeriods, getLocaleBillingPeriodsContentful, useBillingPeriodContent, useDisplayPriceContent, usePrice, usePricingContext, usePromotionalDisclaimerContent, useWranglerPrice };
